import { useState } from 'react';

const FAQ = () => {
  const faqs = [
    {
      question: "What is Civic Guru?",
      answer: "Civic Guru is an AI-powered legal assistant available on WhatsApp that helps simplify legal information and makes it more accessible to everyone. It provides easy-to-understand explanations of legal concepts and can connect you with legal professionals when needed."
    },
    {
      question: "How does Civic Guru work?",
      answer: "Simply send your legal questions to Civic Guru through WhatsApp, and our AI system will provide clear, simple explanations in everyday language. The system can help you understand your rights, explain legal procedures, and guide you through basic legal processes."
    },
    {
      question: "Is Civic Guru available 24/7?",
      answer: "Yes, Civic Guru is available 24/7 through WhatsApp. You can ask questions and receive automated responses at any time, making legal assistance accessible whenever you need it."
    },
    {
      question: "How accurate is the legal information provided?",
      answer: "Civic Guru's responses are based on current Zimbabwean law and are regularly updated. However, while we strive for accuracy, the information provided should be used as general guidance and not as a substitute for professional legal advice."
    },
    {
      question: "How much does it cost to use Civic Guru?",
      answer: "Civic Guru is designed to be affordable and accessible. Basic legal information and guidance are available at minimal cost. Specific pricing details are provided when you start using the service."
    },
    {
      question: "Can Civic Guru connect me with a real lawyer?",
      answer: "Yes, if your situation requires professional legal assistance, Civic Guru can connect you with qualified lawyers in our network. This service is optional and separate from the basic AI assistance."
    }
  ];

  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="py-20">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h1>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="border border-gray-200 rounded-lg overflow-hidden"
              >
                <button
                  className="w-full px-6 py-4 text-left bg-white hover:bg-gray-50 focus:outline-none flex justify-between items-center"
                  onClick={() => toggleFAQ(index)}
                >
                  <span className="text-lg font-semibold text-gray-900">
                    {faq.question}
                  </span>
                  <span className="ml-6">
                    <svg
                      className={`w-6 h-6 transform transition-transform ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </span>
                </button>
                {openIndex === index && (
                  <div className="px-6 py-4 bg-gray-50">
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-gray-600">
              Don't see your question here?{' '}
              <a
                href="mailto:info@civicguru.app"
                className="text-blue-600 hover:text-blue-700"
              >
                Contact us
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ; 